import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../config";

export function useCreatePromotionTrigger() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ data }) => {
            const res = await api.post(`/promotions-trigger/triggers`, data);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(['promotion-triggers']);
        }
    });
}

export function useUpdatePromotionTrigger() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ triggerId, data }) => {
            const res = await api.put(`/promotions-trigger/triggers/${triggerId}`, data);
            return res.data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(['promotion-triggers']);
            queryClient.invalidateQueries(['promotion-trigger', variables.triggerId]);
        }
    });
}

export function useDeletePromotionTrigger() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ triggerId }) => {
            const res = await api.delete(`/promotions-trigger/triggers/${triggerId}`);
            return res.data;
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries(['promotion-triggers']);
            queryClient.removeQueries(['promotion-trigger', variables.triggerId]);
        }
    });
}

export function useCreatePromotionTriggerSettings() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ data }) => {
            const res = await api.post(`/promotions-trigger/settings`, data);
            return res.data;
        },
        onSuccess: () => {
            // Invalidar apenas as queries de settings, sem causar refetch desnecessário
            queryClient.invalidateQueries({ queryKey: ['promotion-trigger-settings'] });
        }
    });
}

export function useUpdatePromotionTriggerSettings() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ settingsId, data }) => {
            const res = await api.put(`/promotions-trigger/settings/${settingsId}`, data);
            return res.data;
        },
        onSuccess: () => {
            // Invalidar apenas as queries de settings, sem causar refetch desnecessário
            queryClient.invalidateQueries({ queryKey: ['promotion-trigger-settings'] });
        }
    });
}

export function useDeletePromotionTriggerSettings() {
    const queryClient = useQueryClient();
    
    return useMutation({
        mutationFn: async ({ settingsId }) => {
            const res = await api.delete(`/promotions-trigger/settings/${settingsId}`);
            return res.data;
        },
        onSuccess: () => {
            // Invalidar apenas as queries de settings, sem causar refetch desnecessário
            queryClient.invalidateQueries({ queryKey: ['promotion-trigger-settings'] });
        }
    });
}